/* eslint-disable max-nested-callbacks */
import AnalysisAction from 'quality/actions/AnalysisAction'
import { CATCHMENT_LIST_SUM_PESTICIDES, DEFAULT_REGROUPMENT, DEFAULT_THRESHOLD_PESTICIDES_1, NITRATES_CODE, CATCHMENT_PESTICIDES, CATCHMENT_IRRELEVANT_PESTICIDES, DEFAULT_THRESHOLD_IRRELEVANT_PESTICIDES, SUM_PESTICIDES_LABO } from 'catchment/constants/CatchmentConstant'
import MessageCard from 'components/card/MessageCard'
import ProgressCard from 'components/card/ProgressCard'
import Checkbox from 'components/forms/Checkbox'
import { groupBy, isUndefined, keys, uniq } from 'lodash'
import moment from 'moment'
import QualityAction from 'quality/actions/QualityAction'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import WatermassAction from 'referencial/components/watermass/actions/WatermassAction'
import i18n from 'simple-react-i18n'
import useApplicationSetting, { intParser, listStringParser } from 'utils/customHook/useApplicationSetting'
import useSandreList from 'utils/customHook/useSandreList'
import useTitle from 'utils/customHook/useTitle'
import { hasValue } from 'utils/NumberUtil'
import { ContaminationEvolutionChart, ContaminationNitratesEvolutionChart, ContaminationPesticidesEvolutionChart } from './ContaminationEvolutionChart'
import { ContaminationNitratesStatusChart, ContaminationPesticidesStatusChart, ContaminationStatusChart } from './ContaminationStatusChart'
import { ContaminationTableSummaryNitrates, ContaminationTableSummaryPesticides } from './ContaminationTableSummary'
import FrequencyPesticides from 'quality/components/qualityComponents/FrequencyPesticides'
import { Card, CardContent, Grid, Stack, Button } from '@mui/material'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import { getBeginingOfTheYear, getEndOfTheYear } from 'utils/DateUtil'
import { NitratesChart, PesticidesChart } from './DistributionChart'
import useStartPeriod from 'catchment/utils/useStartPeriod'
import useEndPeriod from 'catchment/utils/useEndPeriod'
import { THRESHOLD } from 'quality/constants/QualityConstants'
import useAbortController from 'utils/customHook/useAbortController'
import DtoAnalysisUltraLight from 'quality/dto/analyse/DtoAnalysisUltraLight'
import { ObjectivesChartNitrates, ObjectivesChartPesticides } from './ObjectivesChart'
import PropTypes from 'prop-types'
import { StatisticsTableSummaryNitrates, StatisticsTableSummaryPesticides } from './StatisticsTableSummary'
import useAccountSetting from 'utils/customHook/useAccountSetting'
import { SHOW_SANDRE_CODE } from 'account/constants/AccountSettingsConstants'
import { CardTitle } from 'components/card/NewCard'
import useBoolean from 'utils/customHook/useBoolean'
import CatchmentDto from 'catchment/dto/CatchmentDto'
import CatchmentPointDto from 'catchment/dto/CatchmentPointDto'
import { GlobalOverviewMap, NitratesOverviewMap, PesticidesOverviewMap } from './CatchmentsOverviewMaps'
import UnitAction from 'referencial/components/unit/actions/UnitAction'
import DtoQualityThreshold from 'station/components/suivipc/qualitometer/dto/DtoQualityThreshold'

const FilterFields = ({
    defaultFilters = {},
    onValidate = () => {},
}) => {
    const {
        catchments,
        departments,
        watermasses,
    } = useSelector(store => ({
        catchments: store.CatchmentReducer.catchments,
        departments: store.CityReducer.departments,
        watermasses: store.WatermassReducer.watermasses,
    }), shallowEqual)

    const [filters, setFilters] = useState(defaultFilters)

    const sdages = useSandreList('CAPTAGES.SDAGE')

    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : true)
    const showSandreCode = useAccountSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : generalShowSandreCode)

    const watermassList = useMemo(() => {
        return watermasses.filter(w => w.euroCode && catchments.some(c => c.meCode === w.euroCode)).map(w => ({
            code: w.euroCode,
            name: `${showSandreCode ? `[${w.euroCode}]` : ''} ${w.name}`,
        }))
    }, [catchments, watermasses, showSandreCode])

    const onCancel = () => setFilters(defaultFilters)
    const onSearch = () => onValidate(filters)

    return (
        <Card>
            <CardContent>
                <Grid container rowSpacing={1} columnSpacing={2}>
                    <Grid size={2.4}>
                        <SuperMultiAutocomplete
                            label={i18n.department}
                            options={departments}
                            keyValue='code'
                            onChange={v => setFilters({ ...filters, selectedDepartments: v })}
                            values={filters.selectedDepartments}
                            multiple
                            limit={2}
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <SuperMultiAutocomplete
                            label={i18n.sdage}
                            options={sdages}
                            keyValue='code'
                            onChange={v => setFilters({ ...filters, selectedSdages: v })}
                            values={filters.selectedSdages}
                            multiple
                            limit={1}
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <SuperMultiAutocomplete
                            label={i18n.referenceSDAGE}
                            options={sdages}
                            keyValue='code'
                            onChange={v => setFilters({ ...filters, selectedReferenceSdages: v })}
                            values={filters.selectedReferenceSdages}
                            multiple
                            limit={1}
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <SuperMultiAutocomplete
                            label={i18n.watermass}
                            options={watermassList}
                            keyValue='code'
                            onChange={v => setFilters({ ...filters, selectedWatermass: v })}
                            values={filters.selectedWatermass}
                            multiple
                            limit={1}
                            additionalKeysFilter={['code']}
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <SuperMultiAutocomplete
                            label={i18n.catchmentType}
                            options={[
                                { code: 'priority', name: i18n.havePriority },
                                { code: 'sensitive', name: i18n.sensitive },
                            ]}
                            keyValue='code'
                            onChange={v => setFilters({ ...filters, selectedPriorities: v })}
                            values={filters.selectedPriorities}
                            multiple
                            limit={2}
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <Checkbox
                            label={i18n.useP90ForNitrates}
                            checked={filters.useP90}
                            onChange={v => setFilters({ ...filters, useP90: v })}
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <Checkbox
                            label={i18n.displayActiveSDAGE}
                            checked={filters.displayActiveSDAGE}
                            onChange={v => setFilters({ ...filters, displayActiveSDAGE: v })}
                        />
                    </Grid>
                    <Grid size={4.8}>
                        <Checkbox
                            label={i18n.useOnlyDataMainPoint}
                            checked={filters.useOnlyMainPoint}
                            onChange={v => setFilters({ ...filters, useOnlyMainPoint: v })}
                        />
                    </Grid>
                    <Grid size={2.4}>
                        <Checkbox
                            label={i18n.useLastPeriod}
                            checked={filters.useLastPeriod}
                            onChange={v => setFilters({ ...filters, useLastPeriod: v })}
                        />
                    </Grid>
                    <Grid offset={'auto'} size='auto' >
                        <Button
                            variant='outlined'
                            fullWidth
                            onClick={onCancel}
                        >
                            { i18n.reinit }
                        </Button>
                    </Grid>
                    <Grid size='auto' >
                        <Button
                            variant='contained'
                            onClick={onSearch}
                            data-cy='submit'
                        >
                            {i18n.search}
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

FilterFields.propTypes = {
    defaultFilters: PropTypes.shape({}),
    onValidate: PropTypes.func,
}

const NitratesOverview = ({
    nitratesAnalysis = [],
    lastPeriodNitratesAnalysis = [],
    filters = {},
    catchmentFiltered = [],
    catchmentPointFiltered = [],
    qualitoIds = [],
}) => {
    const {
        value: nitratesMap,
        toggle: toggleNitratesMap,
    } = useBoolean(false)
    const nitratesAction = [{
        icon: nitratesMap ? 'list' : 'map',
        onClick: toggleNitratesMap,
        tooltip: nitratesMap ? `${i18n.table} & ${i18n.graph}` : i18n.map,
    }]

    const endPeriod = useEndPeriod(intParser)
    const regroupment = useApplicationSetting('CATCHMENT_REGROUPING', setting => setting ? parseInt(setting) : DEFAULT_REGROUPMENT)
    const lastYear = useMemo(() => moment(endPeriod, 'YYYY').subtract(regroupment - 1, 'years').startOf('year').valueOf(), [endPeriod, regroupment])

    return (
        <Card>
            <CardTitle title={i18n.nitratesFollowUp} actions={nitratesAction} />
            { !!nitratesAnalysis.length && (
                <CardContent>
                    {nitratesMap && (
                        <NitratesOverviewMap
                            analysis={lastPeriodNitratesAnalysis}
                            qualitoIds={qualitoIds}
                            useP90={filters.useP90}
                            catchments={catchmentFiltered}
                            catchmentPoints={catchmentPointFiltered}
                        />
                    ) || (
                        <>
                            <ContaminationNitratesStatusChart
                                catchments={catchmentFiltered}
                                catchmentPoints={catchmentPointFiltered}
                                analysis={lastPeriodNitratesAnalysis}
                                useP90={filters.useP90}
                                referenceSdages={filters.selectedReferenceSdages}
                            />
                            <ContaminationNitratesEvolutionChart
                                catchments={catchmentFiltered}
                                catchmentPoints={catchmentPointFiltered}
                                analysis={nitratesAnalysis}
                                useP90={filters.useP90}
                                referenceSdages={filters.selectedReferenceSdages}
                            />
                            <Stack spacing={2} >
                                <ContaminationTableSummaryNitrates
                                    catchments={catchmentFiltered}
                                    catchmentPoints={catchmentPointFiltered}
                                    analysis={filters.useLastPeriod ? lastPeriodNitratesAnalysis : nitratesAnalysis}
                                    useP90={filters.useP90}
                                    startPeriod={filters.useLastPeriod ? lastYear : 0}
                                />
                                <StatisticsTableSummaryNitrates
                                    catchments={catchmentFiltered}
                                    catchmentPoints={catchmentPointFiltered}
                                    analysis={filters.useLastPeriod ? lastPeriodNitratesAnalysis : nitratesAnalysis}
                                />
                                <Grid container>
                                    <Grid size={6}>
                                        <NitratesChart
                                            catchments={catchmentFiltered}
                                            catchmentPoints={catchmentPointFiltered}
                                            analysis={nitratesAnalysis}
                                            useP90={filters.useP90}
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <ObjectivesChartNitrates
                                            catchments={catchmentFiltered}
                                            catchmentPoints={catchmentPointFiltered}
                                            analysis={nitratesAnalysis}
                                        />
                                    </Grid>
                                </Grid>
                            </Stack>
                        </>
                    )}
                </CardContent>
            ) || <MessageCard>{i18n.noDataToDisplay}</MessageCard>}
        </Card>
    )
}

NitratesOverview.propTypes = {
    nitratesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    lastPeriodNitratesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    filters: PropTypes.shape({
        selectedReferenceSdages: PropTypes.arrayOf(PropTypes.number),
        useLastPeriod: PropTypes.bool,
        useP90: PropTypes.bool,
    }),
    catchmentFiltered: PropTypes.arrayOf(PropTypes.instanceOf(CatchmentDto)),
    catchmentPointFiltered: PropTypes.arrayOf(PropTypes.instanceOf(CatchmentPointDto)),
    qualitoIds: PropTypes.arrayOf(PropTypes.number),
}

const PesticidesOverview = ({
    pesticidesAnalysis = [],
    catchmentFiltered = [],
    catchmentPointFiltered = [],
    filters = {},
    lastPeriodPesticidesAnalysis = [],
    statsTableAnalysis = [],
    frequencyChartAnalysis = [],
    relevantAnalysis = [],
    irrelevantAnalysis = [],
    pesticides = [],
    thresholdList = {},
    qualitoIds = [],
}) => {
    const {
        value: pesticidesMap,
        toggle: togglePesticidesMap,
    } = useBoolean(false)
    const pesticidesAction = [{
        icon: pesticidesMap ? 'list' : 'map',
        onClick: togglePesticidesMap,
        tooltip: pesticidesMap ? `${i18n.table} & ${i18n.graph}` : i18n.map,
    }]

    const thresholdPesticides1 = useApplicationSetting('CATCHMENT_PESTICIDE_THRESHOLD_1', setting => setting ? parseFloat(setting) : DEFAULT_THRESHOLD_PESTICIDES_1)
    const thresholdIrrelevantPesticides = useApplicationSetting('CATCHMENT_PESTICIDE_IRRELEVANT_THRESHOLD', setting => setting ? parseFloat(setting) : DEFAULT_THRESHOLD_IRRELEVANT_PESTICIDES)
    const endPeriod = useEndPeriod(intParser)
    const regroupment = useApplicationSetting('CATCHMENT_REGROUPING', setting => setting ? parseInt(setting) : DEFAULT_REGROUPMENT)
    const lastYear = useMemo(() => moment(endPeriod, 'YYYY').subtract(regroupment - 1, 'years').startOf('year').valueOf(), [endPeriod, regroupment])

    return (
        <Card>
            <CardTitle title={i18n.pesticidesFollowUp} actions={pesticidesAction}/>
            { !!pesticidesAnalysis.length && (
                <CardContent>
                    {pesticidesMap && (
                        <PesticidesOverviewMap
                            analysis={lastPeriodPesticidesAnalysis}
                            qualitoIds={qualitoIds}
                            catchments={catchmentFiltered}
                            catchmentPoints={catchmentPointFiltered}
                            thresholdList={thresholdList}
                        />
                    ) || (
                        <>
                            <ContaminationPesticidesStatusChart
                                catchments={catchmentFiltered}
                                catchmentPoints={catchmentPointFiltered}
                                analysis={lastPeriodPesticidesAnalysis}
                                useP90={filters.useP90}
                                referenceSdages={filters.selectedReferenceSdages}
                            />
                            <ContaminationPesticidesEvolutionChart
                                catchments={catchmentFiltered}
                                catchmentPoints={catchmentPointFiltered}
                                analysis={pesticidesAnalysis}
                                useP90={filters.useP90}
                                referenceSdages={filters.selectedReferenceSdages}
                            />
                            <Stack spacing={2} >
                                <ContaminationTableSummaryPesticides
                                    catchments={catchmentFiltered}
                                    catchmentPoints={catchmentPointFiltered}
                                    analysis={filters.useLastPeriod ? lastPeriodPesticidesAnalysis : pesticidesAnalysis}
                                    useP90={filters.useP90}
                                    startPeriod={filters.useLastPeriod ? lastYear : 0}
                                />
                                <StatisticsTableSummaryPesticides
                                    catchments={catchmentFiltered}
                                    catchmentPoints={catchmentPointFiltered}
                                    analysis={statsTableAnalysis}
                                />
                            </Stack>
                            <FrequencyPesticides
                                pesticidesAnalysis={frequencyChartAnalysis}
                                relevantThreshold={thresholdPesticides1}
                                irrelevantThreshold={thresholdIrrelevantPesticides}
                                specificThresholds={thresholdList?.thresholds ?? []}
                                pesticides={pesticides}
                                title={i18n.allQuantifiedMolecules}
                                startPeriod={filters.useLastPeriod ? lastYear : 0}
                            />
                            <Grid container>
                                <Grid size={6}>
                                    <FrequencyPesticides
                                        pesticidesAnalysis={relevantAnalysis}
                                        uniqueThreshold={thresholdPesticides1}
                                        specificThresholds={thresholdList?.thresholds ?? []}
                                        pesticides={pesticides}
                                        title={i18n.quantifiedRelevantPesticidesCatchments}
                                        startPeriod={filters.useLastPeriod ? lastYear : 0}
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <FrequencyPesticides
                                        pesticidesAnalysis={irrelevantAnalysis}
                                        uniqueThreshold={thresholdIrrelevantPesticides}
                                        specificThresholds={thresholdList?.thresholds ?? []}
                                        pesticides={pesticides}
                                        title={i18n.quantifiedIrrelevantPesticidesCatchments}
                                        startPeriod={filters.useLastPeriod ? lastYear : 0}
                                    />
                                </Grid>
                                <Grid size={6} offset={3}>
                                    <PesticidesChart
                                        catchments={catchmentFiltered}
                                        catchmentPoints={catchmentPointFiltered}
                                        analysis={pesticidesAnalysis}
                                        useP90={filters.useP90}
                                    />
                                </Grid>
                            </Grid>
                            <ObjectivesChartPesticides
                                catchments={catchmentFiltered}
                                catchmentPoints={catchmentPointFiltered}
                                analysis={pesticidesAnalysis}
                                specificThresholds={thresholdList?.thresholds ?? []}
                            />
                        </>
                    )}
                </CardContent>
            ) || <MessageCard>{i18n.noDataToDisplay}</MessageCard>}
        </Card>
    )
}

PesticidesOverview.propTypes = {
    pesticidesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    statsTableAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    frequencyChartAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    relevantAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    irrelevantAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    lastPeriodPesticidesAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    filters: PropTypes.shape({
        selectedReferenceSdages: PropTypes.arrayOf(PropTypes.number),
        useLastPeriod: PropTypes.bool,
        useP90: PropTypes.bool,
    }),
    catchmentFiltered: PropTypes.arrayOf(PropTypes.instanceOf(CatchmentDto)),
    catchmentPointFiltered: PropTypes.arrayOf(PropTypes.instanceOf(CatchmentPointDto)),
    pesticides: PropTypes.arrayOf(PropTypes.string),
    thresholdList: PropTypes.shape({
        threshold: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualityThreshold)),
    }),
    qualitoIds: PropTypes.arrayOf(PropTypes.number),
}

const GlobalOverview = ({
    analysis = [],
    lastPeriodAnalysis = [],
    catchments = [],
    catchmentPoints = [],
    filters = {},
    qualitoIds = [],
    thresholdList = {},
}) => {
    const {
        value: globalMap,
        toggle: toggleGlobalMap,
    } = useBoolean(false)
    const globalAction = [{
        icon: globalMap ? 'list' : 'map',
        onClick: toggleGlobalMap,
        tooltip: globalMap ? `${i18n.table} & ${i18n.graph}` : i18n.map,
    }]

    return (
        <Card>
            <CardTitle title={i18n.globalFollowUp} actions={globalAction} />
            { !!analysis.length && (
                <CardContent>
                    { globalMap && (
                        <GlobalOverviewMap
                            analysis={lastPeriodAnalysis}
                            qualitoIds={qualitoIds}
                            useP90={filters.useP90}
                            catchments={catchments}
                            catchmentPoints={catchmentPoints}
                            thresholdList={thresholdList}
                        />
                    ) || (
                        <>
                            <ContaminationStatusChart
                                catchments={catchments}
                                catchmentPoints={catchmentPoints}
                                analysis={lastPeriodAnalysis}
                                useP90={filters.useP90}
                                referenceSdages={filters.selectedReferenceSdages}
                            />
                            <ContaminationEvolutionChart
                                catchments={catchments}
                                catchmentPoints={catchmentPoints}
                                analysis={analysis}
                                useP90={filters.useP90}
                                referenceSdages={filters.selectedReferenceSdages}
                            />
                        </>
                    ) }
                </CardContent>
            ) || <MessageCard>{i18n.noDataToDisplay}</MessageCard>}
        </Card>
    )
}

GlobalOverview.propTypes = {
    analysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    lastPeriodAnalysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysisUltraLight)),
    catchments: PropTypes.arrayOf(PropTypes.instanceOf(CatchmentDto)),
    catchmentPoints: PropTypes.arrayOf(PropTypes.instanceOf(CatchmentPointDto)),
    filters: PropTypes.shape({
        selectedReferenceSdages: PropTypes.arrayOf(PropTypes.number),
        useP90: PropTypes.bool,
    }),
    qualitoIds: PropTypes.arrayOf(PropTypes.number),
    thresholdList: PropTypes.shape({
        threshold: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualityThreshold)),
    }),
}

const CatchmentsOverviewApp = () => {
    const dispatch = useDispatch()
    const {
        catchments,
        catchmentPoints,
        qualitosIndexCode,
        qualitometers,
        thresholds,
        qualityThresholds,
    } = useSelector(store => ({
        catchments: store.CatchmentReducer.catchments,
        catchmentPoints: store.CatchmentReducer.catchmentPoints,
        qualitosIndexCode: store.QualityReducer.qualitosIndexCode,
        qualitometers: store.QualityReducer.qualitometersLight,
        thresholds: store.QualityReducer.thresholds,
        qualityThresholds: store.QualityReducer.qualityThresholds,
    }), shallowEqual)

    const [progress, setProgress] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [catchmentsAnalysis, setCatchmentsAnalysis] = useState([])

    const [filters, setFilters] = useState({
        selectedDepartments: [],
        selectedSdages: [],
        selectedReferenceSdages: [],
        selectedWatermass: [],
        selectedPriorities: [],
        useP90: false,
        displayActiveSDAGE: false,
        useOnlyMainPoint: true,
        useLastPeriod: true,
    })

    const specificThreshold = useApplicationSetting('CATCHMENT_SPECIFIC_THRESHOLD')
    const relevantPesticides = useApplicationSetting(CATCHMENT_PESTICIDES, listStringParser)
    const irrelevantPesticides = useApplicationSetting(CATCHMENT_IRRELEVANT_PESTICIDES, listStringParser)
    const pesticides = useMemo(() => uniq([...relevantPesticides, ...irrelevantPesticides]), [relevantPesticides, irrelevantPesticides])
    const listSumPesticides = useApplicationSetting(CATCHMENT_LIST_SUM_PESTICIDES, setting => setting?.split(',').filter(c => !!c) || [])
    const allPesticides = useMemo(() => uniq([...pesticides, ...listSumPesticides]), [pesticides, listSumPesticides])
    const excludeProducers = useApplicationSetting('CATCHMENT_PRODUCERS_EXCLUDED', setting => setting?.split(',').filter(c => !!c).map(id => parseInt(id)) || [])

    const startPeriod = useStartPeriod(intParser)
    const endPeriod = useEndPeriod(intParser)
    const regroupment = useApplicationSetting('CATCHMENT_REGROUPING', setting => setting ? parseInt(setting) : DEFAULT_REGROUPMENT)

    const currentYear = useMemo(() => moment(endPeriod, 'YYYY').endOf('year').valueOf(), [endPeriod])
    const lastYear = useMemo(() => moment(endPeriod, 'YYYY').subtract(regroupment - 1, 'years').startOf('year').valueOf(), [endPeriod, regroupment])

    useTitle(() => [{
        title: i18n.catchments,
        href: 'catchment',
    }, {
        title: i18n.overview,
        href: 'catchment/overview',
    }], [])

    useEffect(() => {
        dispatch(WatermassAction.fetchWatermasses())
        dispatch(QualityAction.fetchThresholds())
        dispatch(QualityAction.fetchQualitometersLight())
        dispatch(UnitAction.fetchUnits())
    }, [])

    const thresholdList = useMemo(() => (qualityThresholds.find(t => t.thresholdCode === specificThreshold && t.thresholdType === THRESHOLD.PC) ?? { thresholds: [] }), [qualityThresholds, specificThreshold])

    useEffect(() => {
        if (specificThreshold && thresholds.length) {
            const parseId = parseInt(specificThreshold)
            const th = thresholds.find(t => t.code === parseId)
            if (th) {
                dispatch(QualityAction.fetchQualityThresholds([{ code: th.code, thresholdType: th.thresholdType }]))
            }
        }
    }, [dispatch, specificThreshold, thresholds])

    const formattedCatchmentPoints = useMemo(() => {
        const filteredPoints = catchmentPoints.filter(c => qualitometers.some(q => q.code === c.codeWithoutDesignation))
        const groupByCatchment = groupBy(filteredPoints, 'id')
        return keys(groupByCatchment).flatMap(key => {
            if (groupByCatchment[key].some(p => p.mainPoint)) return groupByCatchment[key]

            return groupByCatchment[key].map((p, i) => {
                if (i === 0) {
                    return {
                        ...p,
                        mainPoint: true,
                    }
                }
                return p
            })
        })
    }, [catchmentPoints, qualitometers])

    const {
        controllerRef,
        initController,
    } = useAbortController()

    useEffect(() => {
        initController()
        // const codes = catchmentPoints.map(p => p.codeWithoutDesignation).filter(c => !!c)
        const qualitoIds = catchmentPoints?.map(point => {
            return qualitometers.find(q => q.code === point.codeWithoutDesignation)?.id
        }).filter(q => !isUndefined(q)) || []
        if (qualitoIds.length) {
            const filter = {
                ultraLightMode: true,
                stations: uniq(qualitoIds),
                startDate: getBeginingOfTheYear(startPeriod),
                endDate: getEndOfTheYear(endPeriod),
                excludedProducers: excludeProducers,
                parameters: uniq([NITRATES_CODE, ...allPesticides, SUM_PESTICIDES_LABO]),
                support: '3', // support 'eau'
            }
            dispatch(AnalysisAction.getAllAnalysisSeq(
                filter,
                controllerRef.current.signal,
                p => setProgress(p),
                json => {
                    setLoaded(true)
                    setCatchmentsAnalysis(json.map(a => new DtoAnalysisUltraLight(a)))
                },
            ))
        }
    }, [dispatch, catchmentPoints, qualitometers, startPeriod, endPeriod, excludeProducers, allPesticides])

    const catchmentFiltered = useMemo(() => {
        const searchActiveSDAGE = filters.displayActiveSDAGE ? catchments.filter(({ activeSdage }) => activeSdage) : catchments
        const watermassFilter = filters.selectedWatermass.length ? searchActiveSDAGE.filter(c => filters.selectedWatermass.includes(c.meCode)) : searchActiveSDAGE
        const departmentFilter = filters.selectedDepartments.length ? watermassFilter.filter(c => filters.selectedDepartments.includes(c.department)) : watermassFilter
        const prioritiesFilter = filters.selectedPriorities.length ? departmentFilter.filter(c => ((c.priority && filters.selectedPriorities.includes('priority')) || (c.sensitive && filters.selectedPriorities.includes('sensitive')))) : departmentFilter
        return filters.selectedSdages.length ? prioritiesFilter.filter(({ usedSdage }) => filters.selectedSdages.includes(usedSdage) || (filters.selectedReferenceSdages.length && filters.selectedReferenceSdages.includes(usedSdage))) : prioritiesFilter
    }, [filters, catchments])

    const catchmentPointFiltered = useMemo(() => {
        return catchmentFiltered.flatMap(c => {
            const points = formattedCatchmentPoints.filter(p => c.id === p.id)
            if (filters.useOnlyMainPoint) {
                return points.filter(p => p.mainPoint)
            }
            return points
        })
    }, [catchmentFiltered, formattedCatchmentPoints, filters.useOnlyMainPoint])

    const qualitoIds = useMemo(() => catchmentFiltered.flatMap(catchment => {
        const points = catchmentPointFiltered.filter(point => point.id === catchment.id)
        return points.map(point => qualitosIndexCode[point.codeWithoutDesignation]?.id).filter(id => hasValue(id))
    }), [catchmentFiltered, catchmentPointFiltered, qualitosIndexCode])

    const analysis = useMemo(() => {
        const filteredAnalysis = catchmentsAnalysis.filter(({ analysisDate, result }) => hasValue(analysisDate) && hasValue(result))
        return filteredAnalysis.filter(a => qualitoIds.includes(a.qualitometer))
    }, [catchmentsAnalysis, qualitoIds])

    const lastPeriodAllAnalysis = useMemo(() => {
        return analysis.filter(a => a.analysisDate < currentYear && a.analysisDate > lastYear)
    }, [analysis, currentYear, lastYear])

    const pesticidesAndNitratesAnalysis = useMemo(() => {
        return analysis.filter(({ parameter }) => parameter === NITRATES_CODE || allPesticides.includes(parameter))
    }, [analysis, allPesticides])

    const lastPeriodAnalysis = useMemo(() => {
        return pesticidesAndNitratesAnalysis.filter(a => a.analysisDate < currentYear && a.analysisDate > lastYear)
    }, [pesticidesAndNitratesAnalysis, currentYear, lastYear])

    const nitratesAnalysis = useMemo(() => {
        return pesticidesAndNitratesAnalysis.filter(({ parameter }) => parameter === NITRATES_CODE)
    }, [pesticidesAndNitratesAnalysis])

    const lastPeriodNitratesAnalysis = useMemo(() => {
        return nitratesAnalysis.filter(a => a.analysisDate < currentYear && a.analysisDate > lastYear)
    }, [nitratesAnalysis, currentYear, lastYear])

    const pesticidesAnalysis = useMemo(() => {
        return pesticidesAndNitratesAnalysis.filter(({ parameter }) => parameter !== NITRATES_CODE)
    }, [pesticidesAndNitratesAnalysis])

    const lastPeriodPesticidesAnalysis = useMemo(() => {
        return pesticidesAnalysis.filter(a => a.analysisDate < currentYear && a.analysisDate > lastYear)
    }, [pesticidesAnalysis, currentYear, lastYear])

    const pesticidesAnalysisWithoutSum = useMemo(() => {
        return pesticidesAnalysis.filter(({ parameter }) => pesticides.includes(parameter))
    }, [pesticides, pesticidesAnalysis])

    const relevantPesticidesAnalysis = useMemo(() => {
        return pesticidesAnalysisWithoutSum.filter(({ parameter }) => relevantPesticides.includes(parameter))
    }, [pesticidesAnalysisWithoutSum, relevantPesticides])

    const irrelevantPesticidesAnalysis = useMemo(() => {
        return pesticidesAnalysisWithoutSum.filter(({ parameter }) => irrelevantPesticides.includes(parameter))
    }, [pesticidesAnalysisWithoutSum, irrelevantPesticides])

    return (
        <Stack sx={{ marginTop: '10px', marginBottom: '100px', marginRight: '10px' }} spacing={1}>
            <FilterFields defaultFilters={filters} onValidate={setFilters} />
            {!loaded && <ProgressCard progress={progress} /> }
            {loaded && (
                <>
                    <GlobalOverview
                        analysis={pesticidesAndNitratesAnalysis}
                        lastPeriodAnalysis={lastPeriodAnalysis}
                        catchments={catchmentFiltered}
                        catchmentPoints={catchmentPointFiltered}
                        filters={filters}
                        qualitoIds={qualitoIds}
                        thresholdList={thresholdList}
                    />
                    <NitratesOverview
                        nitratesAnalysis={nitratesAnalysis}
                        lastPeriodAllAnalysis={lastPeriodAllAnalysis}
                        lastPeriodNitratesAnalysis={lastPeriodNitratesAnalysis}
                        filters={filters}
                        catchmentFiltered={catchmentFiltered}
                        catchmentPointFiltered={catchmentPointFiltered}
                        qualitoIds={qualitoIds}
                    />
                    <PesticidesOverview
                        pesticidesAnalysis={pesticidesAnalysis}
                        catchmentFiltered={catchmentFiltered}
                        catchmentPointFiltered={catchmentPointFiltered}
                        filters={filters}
                        lastPeriodPesticidesAnalysis={lastPeriodPesticidesAnalysis}
                        statsTableAnalysis={filters.useLastPeriod ? lastPeriodAllAnalysis : analysis}
                        frequencyChartAnalysis={pesticidesAnalysisWithoutSum}
                        relevantAnalysis={relevantPesticidesAnalysis}
                        irrelevantAnalysis={irrelevantPesticidesAnalysis}
                        pesticides={pesticides}
                        thresholdList={thresholdList}
                        qualitoIds={qualitoIds}
                    />
                </>
            )}
        </Stack>
    )
}

export default CatchmentsOverviewApp